import { Base64 } from 'js-base64';
import { ICustomer } from '../types';
import UserRoles, { UserRole } from '../common/constants/UserRoles';

export const AuthService = {
    decodeUserData,
    isAccessTokenExpired,
    getKey,
    getRoles,
    hasUserRole,
    isUserAdmin,
    isAnonymous,
    getEmail,
    hasUserAnyOfRoles,
    getCompanyId,
    getCompanyName,
};

function decodeUserData(accessToken: string): ICustomer | null {
    return decodeAccessToken(accessToken);
}

function isAccessTokenExpired(accessToken: string): boolean {
    const customer = decodeAccessToken(accessToken);
    if (!customer) {
        return true;
    }

    // current date in seconds
    const currentTime = Math.floor(new Date().getTime() / 1000);

    return customer.exp <= currentTime;
}

function getKey(accessToken: string, key: string): any {
    const customer = decodeAccessToken(accessToken);

    return customer?.[key] || null;
}

function getRoles(accessToken: string): UserRole[] | null {
    return getKey(accessToken, 'roles');
}

function hasUserRole(accessToken: string, role: UserRole): boolean {
    const roles = getRoles(accessToken);

    return roles?.includes(role) || false;
}

function isUserAdmin(accessToken: string): boolean {
    return hasUserRole(accessToken, UserRoles.manager);
}

function isAnonymous(accessToken: string): boolean {
    return getKey(accessToken, 'anonymous');
}

function getEmail(accessToken: string): boolean {
    return getKey(accessToken, 'email');
}

function decodeAccessToken(accessToken: string): ICustomer | null {
    if (!accessToken) {
        return null;
    }

    const parts = accessToken.split('.');
    const string = parts[1];
    const data = Base64.decode(string);
    try {
        const parsedData = JSON.parse(data);

        if (parsedData && typeof parsedData === 'object') {
            return parsedData;
        }
    } catch (ex) {
        return ex;
    }

    return null;
}

function hasUserAnyOfRoles(accessToken: string, roles: UserRole[]): boolean {
    const userRoles = getRoles(accessToken);

    for (const role of roles) {
        if (userRoles?.includes(role)) {
            return true;
        }
    }

    return false;
}

function getCompanyId(accessToken: string): number | null {
    return getKey(accessToken, 'companyId');
}

function getCompanyName(accessToken: string): string | null {
    return getKey(accessToken, 'company');
}
